import { createAuroraPattern } from "./internal/auroraCore";

export const key = "aurora-colorful-lights";

// aurora-colorful-lights takes up to 4 user-supplied colors. When the user
// hasn't picked any, we fall back to the same default palette as
// aurora-lights so the editor preview still looks like an aurora.
export default createAuroraPattern({
  defaultColors: ["#60a5fa", "#e879f9", "#5eead4", "#a78bfa"],
  useUserColors: true,
});
